import React, { useEffect } from 'react';
import './Withdrawal.css';

const Withdrawal = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="page-container">
      <div className="container">
        <button className="back-button" onClick={() => window.history.back()}>
          <span>←</span><span>Back to Home</span>
        </button>

        <h1>Withdrawal</h1>
        <p className="subtitle">Fast and secure withdrawals with no hidden fees.</p>

        <div className="highlight-box">
          <h3>⚡ Fast Withdrawals</h3>
          <p>Most withdrawal requests are processed within 24 hours.</p>
        </div>

        <div className="section">
          <h2>Withdrawal Methods & Processing Times</h2>
          <table>
            <thead>
              <tr>
                <th>Method</th>
                <th>Processing Time</th>
                <th>Min Withdrawal</th>
                <th>Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>Credit/Debit Card</td><td>1-3 business days</td><td>$50</td><td>$0</td></tr>
              <tr><td>Bank Transfer</td><td>3-5 business days</td><td>$100</td><td>$0</td></tr>
              <tr><td>Skrill</td><td>Instant - 24 hours</td><td>$50</td><td>$0</td></tr>
              <tr><td>Neteller</td><td>Instant - 24 hours</td><td>$50</td><td>$0</td></tr>
              <tr><td>Bitcoin</td><td>24 hours</td><td>$100</td><td>Network fee</td></tr>
            </tbody>
          </table>
        </div>

        <div className="section">
          <h2>How to Withdraw</h2>
          <ol className="withdrawal-steps">
            <li>Log in to your account</li>
            <li>Navigate to "Withdrawal" section</li>
            <li>Select withdrawal method</li>
            <li>Enter amount</li>
            <li>Confirm identity if required</li>
            <li>Submit request</li>
          </ol>
        </div>
      </div>
    </div>
  );
};

export default Withdrawal;